const requisitionCreateInputsGroupsById = ['orderingPhysician', 'createPatient', 'specimenInformation', 'billingInformation'];

export default requisitionCreateInputsGroupsById;